import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Cloudinary } from 'core/services/cloudinary';

@Component({
    selector: 'xm-pricing-comparison-modal',
    templateUrl: 'pricing-comparison.html',
    styleUrls: ['pricing-comparison.scss'],
    standalone: false
})

export class XmPricingComparisonModal {
    public data: CmsPricingComparisonContent;

    private dialogRef: MatDialogRef<CmsPricingComparisonContent>;

    constructor(dialogRef: MatDialogRef<CmsPricingComparisonContent>, @Inject(MAT_DIALOG_DATA) data: CmsPricingComparisonContent) {
        Object.assign(this, { data, dialogRef });
    }

    public close(action: string): void {
        const response: ModalResponse = {
            close: action === 'close',
            primary: action === 'primary',
            secondary: action === 'secondary'
        };

        this.dialogRef.close(response);
    }

    public createImageOption(image: CmsMediaImage): MediaImageOptions {
        return {
            mobile: Cloudinary.generateMediaFromCms(image)
        };
    }
}
